module.exports = __webpack_public_path__ + "static/media/14-RotHeatExchanger - No cool - No heat.bd10ee10.png";